// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn-1GX5i btn-3FsRe","checkbox":"checkbox-1OWvW","fieldset":"fieldset-3gdOu","p":"p-1DhYJ","upload":"upload-2c1Lu","textarea":"textarea-2WnoQ","doc":"doc-3vY2o"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/profile/edit/style.scss
 ** module id = 122
 ** module chunks = 0
 **/